import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const getters = {
    isAuthenticated: state => !!state.token,
    userData: state => state.data
};

const mutations = {
    'AUTH_SUCCESS': (state, result) => {
        state.token = result.token;
        state.data = result.data;
    },
    'SET_USER_DATA': (state, data) => {
        state.data = data;
    },
    'AUTH_ERROR': (state) => {
        state.token = null
        state.data = null
    }
};

const state = {
    token: localStorage.getItem('user-token') || null,
    data: null
};

const store = new Vuex.Store({
    state,
    getters,
    mutations
});

export default store;